import { Component, EventEmitter, OnDestroy, OnInit, HostListener } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { AnessaTranslationService } from '../../helper/translation/anessa-translation.service';
import { UserpilotReloader } from '../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: [
    './tabs.component.scss',
  ]
})
export class TabsComponent extends UserpilotReloader implements OnInit, OnDestroy {
  onDestroyNotifier = new EventEmitter();
  /** trigger for translation pipe */
  trigger?: string;
  rightValue: string = '';

  constructor(public translationService: AnessaTranslationService) {
    super();
    this.rightValue = this.getBrowserRightValue();
  }

  ngOnInit() {
    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(() => {
        this.trigger = this.translationService.getCurrentLang();
      });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }

  // Listen for window resize to detect zoom changes and update rightValue
  @HostListener('window:resize', [])
  onResize() {
    this.rightValue = this.getBrowserRightValue();
  }

  // Vertical scrollbar widths for different browsers
  getBrowserRightValue(): string {
    const userAgent = navigator.userAgent;
  
    if(userAgent.indexOf("Firefox") > -1) {
      return '0px';
    } 
    else if(userAgent.indexOf("Chrome") > -1 || userAgent.indexOf("Edge") > -1) {
      return this.getPxForZoom(Math.floor(window.devicePixelRatio * 100));
    }
    // Default value
    return '15px';
  }
  
  // Vertical scrollbar widths at different zoom levels
  getPxForZoom(zoomLevel: number): string {
    if(zoomLevel > 145) {
      return '10px';
    }
    else if(zoomLevel > 115 && zoomLevel <= 145) {
      return '12px';
    }
    else if(zoomLevel > 105 && zoomLevel <= 115) {
      return '14px';
    } 
    else if(zoomLevel > 95 && zoomLevel <= 105) {
      return '15px';
    } 
    else if(zoomLevel > 85 && zoomLevel <= 95) {
      return '17px';
    } 
    else if(zoomLevel > 75 && zoomLevel <= 85) {
      return '18px';
    } 
    else if(zoomLevel <= 75) {
      return '20px';
    }
  }

}
